module.exports = __webpack_public_path__ + "static/media/logoMerxVerde.f7137654.svg";